import React from 'react';
import { Link } from 'react-router-dom';
import './ColorOptions.scss';

const ColorOptions = props => {
  const { product, localeInfo, redisCommonData = {} } = props;
  const { ENABLE_COLOR_SWATCH_IMAGE } = redisCommonData;
  const { colorOptions } = product;
  const { domain } = localeInfo;

  // colorOptions.sort(a => {
  //     return a.id === product.id ? -1 : 1;
  // });

  const categoryColor = () => {
    return (
      <div className="colorOptions_availableColors">
        {colorOptions?.map((option, index) => {
          const colors = option.color.split(',');
          const colorTop = colors[0];
          // const colorBottom = option?.glassColor || colorTop;
          const frameColorImg = ENABLE_COLOR_SWATCH_IMAGE && option?.frameColorImage;
          return (
            <div key={index} className="colorOptions_availableColors_color">
              <Link
                className={product.id === option.id ? 'active' : ''}
                title={`${option.brandName} ${option.modelName}`}
                to={{
                  pathname: option.productUrl
                    .replace('https://www.lenskart.com', '')
                    .replace(domain, ''),
                  state: { productId: option.id, section: 'prod' },
                }}
              >
                <span className="colorOptions_colorIcons">
                  <span
                    className="colorOptions_colorIcons_colorTop"
                    style={{
                      background: frameColorImg ? `url(${frameColorImg})` : colorTop,
                      backgroundSize: "100% 100%"
                    }}
                  >
                    {' '}
                  </span>
                  {/* <span
                      className="colorOptions_colorIcons_colorBottom"
                      style={{ background: colorBottom }}
                    ></span> */}
                </span>
              </Link>
            </div>
          );
        })}
      </div>
    );
  };

  return <div className="colorOptions">{colorOptions.length > 0 ? categoryColor() : ''}</div>;
};

export default ColorOptions;
